import { FC } from "react"

import { NavHashLink } from "react-router-hash-link"

interface ISidebarItem {
  id: string
  header: string
  body: JSX.Element
}

interface IProps {
  sidebarItems: ISidebarItem[]
  route: string
  sectionClassName?: string
}

export const SidebarPageContent: FC<IProps> = ({
  sidebarItems,
  route,
  sectionClassName
}) => {
  const links = sidebarItems.map((item, idx) => (
    <li key={idx}>
      <NavHashLink smooth to={route + "#" + item.id}>
        {item.header}
      </NavHashLink>
    </li>
  ))

  const content = sidebarItems.map((item, idx) => (
    <div className="sidebar-content-container" key={idx} id={item.id}>
      <header>{item.header}</header>
      {item.body}
    </div>
  ))

  return (
    <article className="d-flex sidebar-page-container page-content-wrapper">
      <aside>
        <ul className="sidebar-list">{links}</ul>
      </aside>
      <section className={"info-page-txt " + (sectionClassName ?? "")}>
        {content}
      </section>
    </article>
  )
}
